import React from 'react';
import IntroMessage from '../IntroMessage/IntroMessage';
import IntroVideo from '../IntroVideo/IntroVideo';
import { useLanguage } from '../../Contexts/LanguageContext';
import './AppraisalToolPilot.scss';

const AppraisalToolPilot = () => {
  const { getLanguageData } = useLanguage();
const data = getLanguageData();

  return (
    <>
      <h1>{data.heading}</h1>
        <div className='section-spacing atp-section'>                    
          <div className="row-container">
              <IntroMessage />
              <IntroVideo />
          </div>          
        </div>
    </>
  );
};

export default AppraisalToolPilot;
